import { useTokenFragment } from '@web/auth/use-token-fragment';
import { useQueryParams } from '../../../helpers/routing';
import { ValidUrlDefinition, validateNextUrl } from '../helpers/validateNextUrl';
import { useDeepLinkUrl } from './useDeepLinkUrl';

type ExternalTokenData =
  | {
      isLoading: true;
      isError: false;
    }
  | {
      isLoading: false;
      isError: true;
    }
  | {
      isLoading: false;
      isError: false;
      url: ValidUrlDefinition | null;
      token: string;
    };

export const useExternalTokenData = (): ExternalTokenData => {
  const token = useTokenFragment();
  const params = useQueryParams();
  const entityId = params.get('entity') || 'TOP_LEVEL';

  const deepLinkNext = useDeepLinkUrl(params.get('next'), entityId, token);

  if (deepLinkNext.isPending) {
    return {
      isLoading: true,
      isError: false,
    };
  }

  if (!token || deepLinkNext.isError) {
    return {
      isLoading: false,
      isError: true,
    };
  }

  const targetPage = validateNextUrl(deepLinkNext.url, entityId);

  return {
    isLoading: false,
    isError: false,
    url: targetPage,
    token,
  };
};
